/**
 * The one pure rule Story 2.4 has on the frontend: whether a name typed into
 * the "Save this view" prompt is good enough to send. Kept separate from
 * `components/table/SavedViewChips.tsx` so it is testable with no DOM and no
 * network mock (VC-2.4-07's automated half) — the live half (no `POST` fires
 * for the empty case) is proven in a real browser.
 */
export function validateSavedViewName(name: string): string | undefined {
  return name.trim() === "" ? "Name this view before saving it." : undefined;
}
